import {
  Box,
  Button,
  useDisclosure,
  Portal,
  AlertDialog,
  AlertDialogOverlay,
  AlertDialogContent,
  AlertDialogHeader,
  AlertDialogBody,
  AlertDialogFooter,
} from "@chakra-ui/react";
import { useRef, useState } from "react";
import {
  useLocation,
  useParams,
  useHistory,
  useRouteMatch,
  Switch,
  Route,
  Redirect,
} from "react-router-dom";

import ProductList from "./ProductList";
import AddProduct from "./AddProduct";
import AdminNavbar from "components/Navbars/AdminNavbar";

const ProductContainer = () => {
  const history = useHistory();
  const location = useLocation();
  const match = useRouteMatch(); // e.g. /product
  const { isOpen, onOpen, onClose } = useDisclosure();
  const cancelRef = useRef();
  const [selectedProduct, setSelectedProduct] = useState(null);

  // Detect current view from path
  const isAdd = location.pathname.endsWith("/add");
  const isEdit = location.pathname.includes("/edit");

  const breadcrumbs = [
    {
      label: "Προϊόντα",
      onClick: () => history.push(match.url),
      isClickable: isAdd || isEdit,
      isCurrent: !(isAdd || isEdit),
    },
    ...(isAdd || isEdit
      ? [
        {
          label: isEdit ? "Επεξεργασία προϊόντος" : "Προσθήκη προϊόντος",
          isClickable: false,
          isCurrent: true,
        },
      ]
      : []),
  ];

  const handleAddProduct = () => {
    console.log("Navigating to add product...");
    history.push(`${match.url}/add`);
  };


  const handleEdit = (product) => {
    localStorage.setItem("productData", JSON.stringify(product)); // Store in localStorage
    setSelectedProduct(product);
    history.push(`${match.url}/edit/${product.id}`);
  };
  

  const handleDelete = (product) => {
    setSelectedProduct(product);
    onOpen();
  };

  const confirmDelete = () => {
    console.log("Deleted:", selectedProduct);
    onClose();
  };

  const handleBack = () => {
    history.push(match.url);
  };

  const handleAddStatus = () => {
    history.push(match.url);
  };

  return (
    <>
      <Portal>
        <AdminNavbar breadcrumbs={breadcrumbs} logoText="ΚΡΕΑΡΙΣΤΟΝ" />
      </Portal>

      <Switch>
        <Route exact path={match.path}>
          <ProductList
            handleAddProduct={handleAddProduct}
            handleEdit={handleEdit}
            handleDelete={handleDelete}
          />
        </Route>

        <Route exact path={`${match.path}/add`}>
          <AddProduct
            productData={null}
            handleBack={handleBack}
            onaddProductStatus={handleAddStatus}
          />
        </Route>

        <Route exact path={`${match.path}/edit/:id`}>
          <AddProduct
            productData={
              selectedProduct || JSON.parse(localStorage.getItem("productData"))
            }
            handleBack={handleBack}
            onaddProductStatus={handleAddStatus}
          />
        </Route>


        {/* Fallback to product list for unknown routes */}
        <Redirect to={match.url} />
      </Switch>

      <AlertDialog isOpen={isOpen} leastDestructiveRef={cancelRef} onClose={onClose}>
        <AlertDialogOverlay>
          <AlertDialogContent>
            <AlertDialogHeader fontSize="lg" fontWeight="bold">
              Confirm Archive
            </AlertDialogHeader>
            <AlertDialogBody>
              Are you sure you want to archive this product?
            </AlertDialogBody>
            <AlertDialogFooter>
              <Button ref={cancelRef} onClick={onClose}>
                Cancel
              </Button>
              <Button colorScheme="red" onClick={confirmDelete} ml={3}>
                Yes, Archive
              </Button>
            </AlertDialogFooter>
          </AlertDialogContent>
        </AlertDialogOverlay>
      </AlertDialog>
    </>
  );
};

export default ProductContainer;
